/**
 * Images should be stored in the `App/Images` directory and referenced using variables defined here.
 */

export default {
  logo: require('../Assets/svgs/logo.svg'),
  navDoc: require('../Assets/svgs/navDoc.svg'),
  navReviewed: require('../Assets/svgs/navReviewed.svg'),
  navExported: require('../Assets/svgs/navExported.svg'),
  navTemplate: require('../Assets/svgs/navTemplate.svg'),
  help: require('../Assets/svgs/help-nav.svg'),
  helpActive: require('../Assets/svgs/help-active.svg'),
  navDocActive: require('../Assets/svgs/navDocActive.svg'),
  navReviewedActive: require('../Assets/svgs/navReviewedActive.svg'),
  navExportedActive: require('../Assets/svgs/navExportedActive.svg'),
  navTemplateActive: require('../Assets/svgs/navTemplateActive.svg'),
  doc: require('../Assets/svgs/navDoc.svg'),
  fieldRight: require('../Assets/svgs/fieldRight.svg'),
  zoomIn: require('../Assets/svgs/zoom-in.svg'),
  zoomOut: require('../Assets/svgs/zoom-out.svg'),
  fitPage: require('../Assets/svgs/fit-page.svg'),
  error: require('../Assets/svgs/error.svg'),
  loginSample: require('../Assets/sampleImages/loginSample.png'),
  importDoc: require('../Assets/svgs/import-doc.svg'),
  importDoc1: require('../Assets/svgs/import-doc-1.svg'),
  check: require('../Assets/svgs/check.svg'),
  png: require('../Assets/svgs/png.svg'),
  pngInactive: require('../Assets/svgs/pngInactive.svg'),
  pdf: require('../Assets/svgs/pdf.svg'),
  pdfInactive: require('../Assets/svgs/pngInactive.svg'),
  delete: require('../Assets/svgs/delete.svg'),
  closeSelection: require('../Assets/svgs/close-selection.svg'),
  assignUser: require('../Assets/svgs/assign-user.svg'),
  sort: require('../Assets/svgs/sort.svg'),
  reverseSort: require('../Assets/svgs/reverseSort.svg'),
  progress: require('../Assets/svgs/progress.svg'),
  progressDone: require('../Assets/svgs/progress-done.svg'),
  search: require('../Assets/svgs/search.svg'),
  folder: require('../Assets/svgs/folder.svg'),
  expand: require('../Assets/svgs/arrow-dn.svg'),
  cancel: require('../Assets/svgs/doc-wrong.svg'),
  miniPdf: require('../Assets/svgs/miniPdf.svg'),
  docRight: require('../Assets/svgs/docRight.svg'),
  bigLogo: require('../Assets/svgs/bigLogo.svg'),
  message: require('../Assets/svgs/message.svg'),
  inactiveMessage: require('../Assets/svgs/inactiveMessage.svg'),
  exportSingle: require('../Assets/svgs/exportSingle.svg'),
  edit: require('../Assets/svgs/working.svg'),
  docDelete: require('../Assets/svgs/docDelete.svg'),
  nextArrow: require('../Assets/svgs/nextArrow.svg'),
  backArrow: require('../Assets/svgs/backArrow.svg'),
  nextArrowInactive: require('../Assets/svgs/nextArrowInactive.svg'),
  backArrowInactive: require('../Assets/svgs/backArrowInactive.svg'),
  download: require('../Assets/svgs/download.svg'),
  profile: require('../Assets/svgs/user.svg'),
  lock: require('../Assets/svgs/password.svg'),
  importSmall: require('../Assets/svgs/importSmall.svg'),
  reviewed: require('../Assets/svgs/reviewed.svg'),
  draft: require('../Assets/svgs/draft.svg'),
  exported: require('../Assets/svgs/export.svg'),
  stats: require('../Assets/svgs/stats.svg'),
  settings: require('../Assets/svgs/settings.svg'),
  users: require('../Assets/svgs/users.svg'),
  back: require('../Assets/svgs/back.svg'),
  statsActive: require('../Assets/svgs/statsActive.svg'),
  settingsActive: require('../Assets/svgs/settingsActive.svg'),
  usersActive: require('../Assets/svgs/usersActive.svg'),
  pending: require('../Assets/svgs/pending.svg'),
  pendingActive: require('../Assets/svgs/pendingActive.svg'),
  ip: require('../Assets/svgs/ip.svg'),
  domain: require('../Assets/svgs/domain.svg'),
  ent: require('../Assets/svgs/ent.svg'),
  bgImage: require('../Assets/Images/bgImage.jpg'),
  wave: require('../Assets/svgs/wave.svg'),
  ipActive: require('../Assets/svgs/ipActive.svg'),
  domainActive: require('../Assets/svgs/domainActive.svg'),
  entActive: require('../Assets/svgs/entActive.svg'),
  visibilityIcon: require('../Assets/svgs/eye-on.svg'),
  visibilityOffIcon: require('../Assets/svgs/eye-off.svg'),
  serverError: require('../Assets/svgs/serverError.svg'),

}